import React from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import PhotoCollage from './components/PhotoCollage/PhotoCollage';

function App() {
  const backgroundSentences = [
    'Security Protocol Implementation',
    'Network Defense Systems',
    'Full Stack Development',
    'Secure Code Design',
    'Database Management Solutions',
    'API Integration Services',
    'Cloud Security Architecture',
    'System Performance Optimization',
    'User Experience Design',
    'Cybersecurity Best Practices',
    'Web Application Security',
    'Infrastructure Management',
    'Penetration Testing Expert',
    'Vulnerability Assessment',
    'Incident Response Planning',
    'Security Audit Solutions',
    'Malware Analysis Skills',
    'Threat Detection Systems',
    'Encryption Implementation',
    'Firewall Configuration',
    'DevOps Best Practices',
    'CI/CD Pipeline Setup',
    'Docker Containerization',
    'Kubernetes Orchestration',
    'React Frontend Design',
    'Node.js Backend Systems',
    'MongoDB Database Design',
    'Redis Cache Solutions',
    'AWS Cloud Architecture',
    'Azure Security Services'
  ];

  const getRandomPosition = (index) => {
    // Random starting positions across the entire viewport
    const startLeft = Math.random() * 100; // Random horizontal position
    const startTop = Math.random() * 100; // Random vertical position
    
    // Create different movement patterns
    const pattern = index % 4; // 4 different movement patterns
    const direction = index % 2 === 0 ? 'normal' : 'reverse';
    const movementClass = `floating-pattern-${pattern}`;
    
    // Vary the animation duration and delay
    const duration = 20 + (Math.random() * 15); // 20-35 seconds
    const delay = Math.random() * 10; // Random delay up to 10 seconds
    
    return {
      left: `${startLeft}%`,
      top: `${startTop}%`,
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
      opacity: 0.7 + (Math.random() * 0.3),
      animationDirection: direction,
      className: `floating-sentence ${movementClass}`
    };
  };

  return (
    <div className="app">
      <Navbar />
      
      <div className="floating-background">
        {backgroundSentences.map((sentence, index) => {
          const styles = getRandomPosition(index);
          const { className, ...styleProps } = styles;
          return (
            <div
              key={index}
              className={className}
              style={styleProps}
            >
              {sentence}
            </div>
          );
        })}
      </div>

      <main>
        <section id="home" className="hero-section">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                <div className="title-top">Welcome to My</div>
                <div className="title-bottom">World of</div>
                <div className="title-highlight">
                  Security &<br />
                  Development
                </div>
              </h1>
              <div className="identity-text">
                <span>I</span>
                <span>am</span>
                <span>a</span>
              </div>
              <div className="rotating-text">
                <span>Full Stack Developer</span>
                <span>Security Specialist</span>
                <span>Penetration Tester</span>
              </div>
              <p className="hero-tagline">
                Transforming complex security challenges into robust solutions
              </p>
              <div className="cta-buttons">
                <a href="#projects" className="cta-button primary">View My Work</a>
                <a href="#contact" className="cta-button secondary">Get in Touch</a>
              </div>
            </div>

            <div className="hero-visual">
              <PhotoCollage />
            </div>
          </div>
        </section>

        <About />
        <Skills />
        <Projects />
        <Contact />
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
